import { render, staticRenderFns } from "./NameView.vue?vue&type=template&id=a04e992a&"
import script from "./NameView.vue?vue&type=script&lang=js&"
export * from "./NameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports